module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "img-view",
    on: {
      "click": _vm.bigImg
    }
  }, [_c('div', {
    staticClass: "img-layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-457260f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/assets/BigImg.vue
// module id = 1273
// module chunks = 1